define('drops/video/video',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/videoPlayer'
], function ($, Drop, Style, VideoPlayer) {
    'use strict';

    var defaults = {
        data: {
            value: '',
            loop: false,
            controls: true
        }
    };

    function Video(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.player = new VideoPlayer(this.$element);

        if (this.data.size.x < 200)
            this.data.size.x = 200;
        if (this.data.size.y < 100)
            this.data.size.y = 100;

        this.$element
	        .addClass('boxToBorderSize')
	        .css({
	            whiteSpace: 'pre-wrap',
	            overflow: 'hidden'
	        });

        Style.renderStyles(this);

        return this;
    };

    Drop.extend(Video, Drop);

    Video.typeName = 'Video';

    Video.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    Video.prototype.postRender = function () {
        if(this.isVisible())
            this.openVideoPlayer();
    };

    Video.prototype.afterShown = function () {
        this.openVideoPlayer();
    };

    Video.prototype.afterHidden = function () {
        this.player.close();
    };

    Video.prototype.openVideoPlayer = function () {
        var config = {
            url: this.data.value,
            autoPlay: this.data.autoPlay,
            poster: this.data.poster,
            loop: this.data.loop,
            controls: this.data.controls
        };

        if (this.isEventEnabled('videoEnded'))
            config.onEnded = this.triggerEventIfEnabled.bind(this, 'videoEnded');

        this.player.open(config);
    };

    return Video;
});




